<template>
  <div>
    <a-table v-if="relationTasks.length > 0" :pagination="false" size="small" :columns="selectedColumns" row-key="id" :data-source="relationTasks">
      <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
      <span slot="customTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="story_title" :href="link(record)" target="_blank">{{ record.name }}</a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="taskStatus[record.status].status" :color="taskStatus[record.status].color" :text="taskStatus[record.status].label" />
      </span>
      <span slot="action" slot-scope="text, record, index">
        <a @click="onRemove(index)">移除</a>
      </span>
    </a-table>
    <a-button icon="search" type="dashed" class="search-button" @click="onSelect"> 选择任务 </a-button>
    <a-modal v-model="visible" :width="1040" title="选择独立任务" @ok="handleOk" @cancel="close">
      <a-alert v-if="taskDisabled && ![19, 20].includes(templateId)" message="仅能选择未被其他流程未关联且为“已完成”状态的独立任务" type="info" />
      <a-row :gutter="12">
        <a-col :span="5">
          <a-card size="small" title="选择迭代" style="width: 100%; margin-top: 8px">
            <a-skeleton :loading="versionLoading">
              <div v-for="(version, index) in versionData" :key="index">
                <div :class="`${version.id === currentVersion ? 'version-item version-item_active' : 'version-item'}`" @click="onVersion(version.id)">
                  <span class="version-item_name">{{ version.title }} </span>
                </div>
              </div>
            </a-skeleton>
          </a-card>
        </a-col>
        <a-col :span="19">
          <a-input-search v-model="searchKeyword" placeholder="ID或标题搜索" class="requirement_search" allow-clear enter-button @search="onSearch" />
          <a-table :scroll="{ y: 380 }" :loading="loading" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :data-source="taskData" @change="handleTableChange">
            <span slot="customId" slot-scope="text, record">
              {{ record.key }}
              <a-popover title="原因">
                <template slot="content">
                  <div>已关联其他评审单</div>
                </template>
                <a-icon v-if="record.disabled === true" type="info-circle" />
              </a-popover>
            </span>
            <span slot="customTitle" slot-scope="text, record">
              <a-tooltip placement="top" :title="record.name">
                <a class="story_title" :href="link(record)" target="_blank">{{ record.name }}</a>
              </a-tooltip>
            </span>
            <span slot="status" slot-scope="text, record">
              <a-badge :status="taskStatus[record.status].status" :color="taskStatus[record.status].color" :text="taskStatus[record.status].label" />
            </span>
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { versionList } from '@/api/project/version';
import { taskStatus } from '@/utils/dictionary';
import { taskList } from '@/api/project/task';

const columns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  }
];
const selectedColumns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    templateId: {
      type: [Number],
      default: null
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      selectedColumns,
      loading: false,
      visible: false,
      tasks: {},
      taskData: [],
      selected: [],
      selectedRowKeys: [],
      versionLoading: false,
      currentVersion: null,
      versionData: [],
      searchKeyword: '',
      taskDisabled: true,
      taskIds: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    relationTasks() {
      return this.selected.map(key => {
        return this.tasks[key];
      });
    },

    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:task:detail',
          query: { taskId: record.id }
        }).href;
      };
    },

    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.selected = newVal;
      },
      immediate: true
    },
    selected() {
      this.$emit('change', this.selected);
    },
    taskList: {
      handler(newVal) {
        this.tasks = newVal;
      },
      immediate: true
    }
  },
  methods: {
    getVersionList() {
      this.versionLoading = true;
      versionList({ status: [0], project_id: this.projectId })
        .then(res => {
          this.versionData = res.data.list;
          if (this.currentVersion === null) {
            this.currentVersion = this.versionData[0].id;
          }
          this.versionLoading = false;
          this.getTaskList();
        })
        .catch(() => {
          this.versionLoading = false;
        });
    },

    onVersion(version_id) {
      this.currentVersion = version_id;
      this.getTaskList();
    },

    getTaskList() {
      this.loading = true;
      const form = {
        project_id: this.projectId,
        keyword: this.searchKeyword,
        version: this.currentVersion,
        codingTask: 1,
        status: [3],
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      };
      // 端交付流程和集成发版流程只能关联类型为「端任务」的任务
      if ([19, 20].includes(this.templateId)) {
        form.objective = [68];
      }
      // 集成发版流程可关联已上线的任务
      if ([20].includes(this.templateId)) {
        form.status = [7];
      }
      taskList(form)
        .then(res => {
          if ([20].includes(this.templateId)) {
            this.taskData = res.data.items.map(item => {
              return { ...item, disabled: false };
            });
          } else {
            this.taskData = res.data.items;
          }
          // this.taskDisabled = res.data.requirement_disabled;
          this.taskIds = res.data.requirement_ids;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.getTaskList();
    },

    onSearch() {
      this.pagination.current = 1;
      this.getTaskList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.tasks, item.id, { id: item.id, key: item.key, name: item.name, status: item.status });
      });
    },

    onSelect() {
      this.visible = true;
      this.selectedRowKeys = [...this.selected];
      this.getVersionList();
    },

    onRemove(index) {
      this.selected.splice(index, 1);
    },

    handleOk() {
      this.selected = [...this.selectedRowKeys];
      this.close();
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:task:detail',
        query: {
          taskId: record.id
        }
      });
    },

    close() {
      this.visible = false;
      this.selectedRowKeys = [];
    }
  }
};
</script>
<style lang="less" scoped>
.search-button {
  width: 100%;
}

.story_title:hover {
  cursor: pointer;
  color: #1890ff;
}

.story_title {
  color: rgba(0, 0, 0, 0.65);
}

.requirement_search {
  margin: 8px 0;
}

/deep/.ant-modal-body {
  padding: 12px;
}

/deep/.ant-card-body {
  padding: 8px;
  height: 470px;
  overflow: auto;
}

.version-item {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
  padding: 0 8px;
  margin: 2px -8px;
  display: -webkit-box;
  /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical;
  /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 1;
  /**显示的行数**/
  overflow: hidden;
  /**隐藏超出的内容**/
}

.version-item:hover,
.version-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.version-item_more {
  float: right;
  font-weight: bold;
}
</style>
